import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import {
  IntegrationCategory,
  InternalIntegrationSetting,
} from 'models/InternalIntegrationSetting';
import { QueryKey } from '@tanstack/react-query';
import { Alert } from 'react-bootstrap';
import useDisableIntegrationMutation, {
  IntegrationMutationLevel,
} from 'pages/integrations/hooks/useDisableIntegrationMutation';

const useDisableAgencyChannelModal = () => {
  const { t } = useTranslation();
  const { openConfirmModal } = useAppModal();
  const { disableIntegration } = useDisableIntegrationMutation();

  const openDisableAgencyIntegrationModal = ({
    integration,
    queryKey,
  }: {
    integration: InternalIntegrationSetting;
    queryKey: QueryKey;
  }) => {
    const channelName =
      integration.integration.displayName ?? integration.integration.name;
    const isChannelManager =
      integration.integration.category === IntegrationCategory.CHANNEL_MANAGER;

    const handleConfirmDisable = async () => {
      await disableIntegration({
        level: IntegrationMutationLevel.AGENCY,
        enumId: integration.enumId,
        queryKey,
      });
    };

    openConfirmModal({
      title: t('pageChannels.modals.disableChannelIntegration.title', {
        channel: channelName,
      }),
      body: (
        <>
          <p>
            {t('pageChannels.modals.disableChannelIntegration.question', {
              channel: channelName,
              context: isChannelManager ? 'channelManager' : null,
            })}
          </p>

          <Alert bsStyle="danger">
            {t('pageChannels.modals.disableChannelIntegration.alert', {
              context: isChannelManager ? 'channelManager' : null,
            })}
          </Alert>
        </>
      ),
      confirmLabel: t(
        'pageChannels.modals.disableChannelIntegration.confirmLabel',
        {
          channel: channelName,
        },
      ),
      confirmColor: 'danger',
      onConfirmAsync: handleConfirmDisable,
    });
  };

  return { openDisableAgencyIntegrationModal };
};

export default useDisableAgencyChannelModal;
